import { Button } from '@sparemin/blockhead';
import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesome from 'components/FontAwesome';
import { getDownloadPath } from 'utils/routes';
import {
  useIsRegeneratingProject,
  useIsShareDisabled,
  useProjectWidgetId,
} from './ProjectPreviewModalContext';
import { ProjectPreviewModalAction } from './types';
import { block } from './utils';

export interface ProjectPreviewModalShareButtonProps {
  onAction: (action: ProjectPreviewModalAction) => void;
}

const ProjectPreviewModalShareButton: React.FC<ProjectPreviewModalShareButtonProps> = ({
  onAction,
}) => {
  const widgetId = useProjectWidgetId();
  const isRegeneratingProject = useIsRegeneratingProject();

  const isShareDisabled = useIsShareDisabled();

  return (
    <Button
      as={widgetId ? Link : undefined}
      to={!isRegeneratingProject && getDownloadPath(widgetId)}
      target="_blank"
      variant="special"
      startIcon={<FontAwesome icon="share" />}
      className={block('share-link-button')}
      isDisabled={isShareDisabled}
      onPress={() => !isRegeneratingProject && onAction('download')}
    >
      Share
    </Button>
  );
};

export default ProjectPreviewModalShareButton;
